/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { spawnDialog } from '@nextcloud/vue/functions/dialog';
import NewNodeDialog from '../components/NewNodeDialog.vue';
/**
 * Ask user for file or folder name
 * @param defaultName Default name to use
 * @param folderContent Nodes with in the current folder to check for unique name
 * @param options Options for the dialog
 * @return string if successful otherwise null if aborted
 */
export function newNodeName(defaultName, folderContent, options = {}) {
    const contentNames = folderContent.map((node) => node.basename);
    return new Promise((resolve) => {
        spawnDialog(NewNodeDialog, {
            ...options,
            defaultName,
            otherNames: contentNames,
        }, (folderName) => {
            resolve(folderName);
        });
    });
}
